import {ProductAdminzoneState} from "@/types/store/adminzone/products";
import { ProductData } from "@/types";

export const state: ProductAdminzoneState = {
  products: [] as Array<ProductData>
}
